// headers for the api request
const headers = {
  "Content-Type": "application/x-www-form-urlencoded",
  "X-Requested-With": "XMLHttpRequest",
};

// function to get totaliser stats
export const getTotaliserStats = async (campaignId, contributionPageId) => {
  return fetch("/civicrm/ajax/api4/Totaliser/Stats", {
    method: "POST",
    headers,
    body: new URLSearchParams({
      params: JSON.stringify({
        where: [
          ["campaign_id", "=", campaignId],
          ["contribution_page_id", "=", contributionPageId],
        ],
      }),
    }),
  })
    .then((res) => {
      return res.json();
    })
    .then((records) => {
      return records.values[0];
    });
};
